import * as React from 'react';

import { Star } from '../Star';
import * as styles from './StarInput.css';

export interface IStarInputProps {
  onMouseEnter(): void;
  onMouseLeave(): void;
  onClick(): void;
  name: string;
  value: number;
  isActive: boolean;
  isHover: boolean;
}

export const StarInput = (props: IStarInputProps) => {
  const { isHover, isActive, value, name, onMouseEnter, onMouseLeave, onClick } = props;

  return (
    <label
      data-testid="StarInput"
      className={styles['star']}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <input className={styles['input']} name={name} type="radio" value={value} />
      <Star isActive={isActive} isHover={isHover} />
    </label>
  );
};
